export const GET_ARTICLE_INFO = 'GET_ARTICLE_INFO' as const;
export const GET_ARTICLE_INFO_PENDING = 'GET_ARTICLE_INFO_PENDING' as const;
export const GET_ARTICLE_INFO_FULFILLED = 'GET_ARTICLE_INFO_FULFILLED' as const;
export const GET_ARTICLE_INFO_REJECTED = 'GET_ARTICLE_INFO_REJECTED' as const;
export const GET_ARTICLE_PUSHES = 'GET_ARTICLE_PUSHES' as const;
export const GET_ARTICLE_PUSHES_PENDING = 'GET_ARTICLE_PUSHES_PENDING' as const;
export const GET_ARTICLE_PUSHES_FULFILLED = 'GET_ARTICLE_PUSHES_FULFILLED' as const;
export const GET_ARTICLE_PUSHES_REJECTED = 'GET_ARTICLE_PUSHES_REJECTED' as const;
export const GET_ARTICLE_PUSHES_STATS = 'GET_ARTICLE_PUSHES_STATS' as const;
export const GET_ARTICLE_PUSHES_STATS_PENDING = 'GET_ARTICLE_PUSHES_STATS_PENDING' as const;
export const GET_ARTICLE_PUSHES_STATS_FULFILLED = 'GET_ARTICLE_PUSHES_STATS_FULFILLED' as const;
export const GET_ARTICLE_PUSHES_STATS_REJECTED = 'GET_ARTICLE_PUSHES_STATS_REJECTED' as const;
export const GET_ARTICLE_REPLIES = 'GET_ARTICLE_REPLIES' as const;
export const GET_ARTICLE_REPLIES_PENDING = 'GET_ARTICLE_REPLIES_PENDING' as const;
export const GET_ARTICLE_REPLIES_FULFILLED = 'GET_ARTICLE_REPLIES_FULFILLED' as const;
export const GET_ARTICLE_REPLIES_REJECTED = 'GET_ARTICLE_REPLIES_REJECTED' as const;
